import asyncRoute from '../AsyncRoute'

export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-order-tests-dom').OrderTests
      resolve(View)
    }, 'hfty-order-tests-dom')
  })
}

export default asyncRoute({ getComponent, reducers: [] })
